import React from 'react';
import Container from './Container';
import { TransitionItem } from '~helpers';
import { H4, H5 } from '~typography';
import authPropTypes from '../../prop-types/authPropTypes';

var OneMoreStepMessage = function OneMoreStepMessage(_ref) {
  var oneMoreStep = _ref.oneMoreStep,
      oneMoreStepMessage = _ref.oneMoreStepMessage;

  if (!oneMoreStepMessage) {
    return null;
  }

  var title = oneMoreStepMessage.title,
      subtitle = oneMoreStepMessage.subtitle,
      body = oneMoreStepMessage.body;
  return /*#__PURE__*/React.createElement(TransitionItem, {
    inProp: oneMoreStep,
    appear: true,
    mountOnEnter: true
  }, /*#__PURE__*/React.createElement(Container, null, title && /*#__PURE__*/React.createElement(H4, {
    color: "muted"
  }, title), subtitle && /*#__PURE__*/React.createElement(H5, {
    color: "muted"
  }, subtitle), body));
};

OneMoreStepMessage.defaultProps = {
  oneMoreStep: false,
  oneMoreStepMessage: undefined
};
export default OneMoreStepMessage;